import dynamic from "next/dynamic";

export const AwardCard = dynamic(() => import("./component"));
